module.exports = __webpack_public_path__ + "img/books-big.67e75972.jpg";